<template>
  <div class="stock-stat-cards">
    <div
      v-for="card in cards"
      :key="card.filter"
      :class="['stock-stat-card', 'filter-' + card.filter, { active: activeFilter === card.filter }]"
      role="button"
      tabindex="0"
      @click="$emit('filter-change', card.filter)"
      @keydown.enter="$emit('filter-change', card.filter)"
    >
      <div :class="['stock-stat-icon', card.color]">
        <i :class="card.icon + ' icon'"></i>
      </div>
      <div class="stock-stat-info">
        <div class="stock-stat-value">{{ card.value }}</div>
        <div class="stock-stat-label">{{ card.label }}</div>
        <div class="stock-stat-sublabel">{{ card.sublabel }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StockStatCards',
  props: {
    stats: { type: Object, required: true },
    activeFilter: { type: String, default: 'all' },
    marketplaceCount: { type: Number, default: 0 }
  },
  computed: {
    cards: function () {
      return [
        {
          filter: 'all',
          color: 'blue',
          icon: 'warehouse',
          value: this.stats.totalProducts,
          label: 'Total Products',
          sublabel: 'Tracked across ' + this.marketplaceCount + ' marketplace' + (this.marketplaceCount !== 1 ? 's' : '')
        },
        {
          filter: 'healthy',
          color: 'green',
          icon: 'check circle',
          value: this.stats.healthyStock,
          label: 'Healthy Stock',
          sublabel: this.stats.healthyPercentage + '% of products'
        },
        {
          filter: 'low',
          color: 'amber',
          icon: 'exclamation triangle',
          value: this.stats.lowStockWarning,
          label: 'Low Stock Warning',
          sublabel: 'Reorder soon'
        },
        {
          filter: 'critical',
          color: 'red',
          icon: 'times circle',
          value: this.stats.outOfStock,
          label: 'Out of Stock',
          sublabel: 'Revenue at risk'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// StockStatCards.vue?9878de78